import { createAsyncThunk } from '@reduxjs/toolkit';
import { AsyncThunkConfig } from '../../../async-thunk-config';
import { HomeError } from '../home-types';
import { AmlTemplate, StatusResponse } from '../../../../api/generated';
import amlFatcaCrsSurveyRepository from '../../../../repositories/onboarding-self/aml-fatca-crs-survey-repository';
import {
  GetAmlAnswersRequest,
  GetFatcaRequest,
  PostFatcaRequest,
} from './home-onboarding-self-aml-fatca-crs-survey-types';
import { DatiFatca, SurveyRisposte } from '../../../../api/generated/dob';

export const getAmlPfSurvey = createAsyncThunk<
  AmlTemplate,
  string,
  AsyncThunkConfig<HomeError>
>('get-aml-pf-survey', async (amlType: string, thunkApi) => {
  try {
    return await amlFatcaCrsSurveyRepository.getAmlSurvey(amlType, thunkApi);
  } catch (error) {
    console.error(error);
    return thunkApi.rejectWithValue('GENERIC_ERROR');
  }
});

export const getAmlPfSurveyResponse = createAsyncThunk<
  SurveyRisposte,
  GetAmlAnswersRequest,
  AsyncThunkConfig<HomeError>
>(
  'get-aml-pf-survey-response',
  async (request: GetAmlAnswersRequest, thunkApi) => {
    const { idCustomer, idIncarico } = request;

    try {
      return await amlFatcaCrsSurveyRepository.getAmlSurveyResponse(
        idCustomer,
        idIncarico,
        thunkApi
      );
    } catch (error) {
      console.error(error);
      return thunkApi.rejectWithValue('GENERIC_ERROR');
    }
  }
);

export const getFatca = createAsyncThunk<
  DatiFatca,
  GetFatcaRequest,
  AsyncThunkConfig<HomeError>
>('get-fatca', async (request: GetFatcaRequest, thunkAPI) => {
  const { idCustomer, idIncarico } = request;

  try {
    return await amlFatcaCrsSurveyRepository.getFatca(
      idCustomer,
      idIncarico,
      thunkAPI
    );
  } catch (error) {
    console.error(error);
    return thunkAPI.rejectWithValue('GENERIC_ERROR');
  }
});

export const postFatca = createAsyncThunk<
  StatusResponse,
  PostFatcaRequest,
  AsyncThunkConfig<HomeError>
>('post-fatca', async (request: PostFatcaRequest, thunkAPI) => {
  const { idCustomer, body } = request;

  try {
    const response = await amlFatcaCrsSurveyRepository.postFatca(
      idCustomer,
      body,
      thunkAPI
    );
    return response;
  } catch (error) {
    console.error(error);
    return thunkAPI.rejectWithValue('GENERIC_ERROR');
  }
});

export const postAml = createAsyncThunk<
  SurveyRisposte,
  SurveyRisposte,
  AsyncThunkConfig<HomeError>
>('post-aml', async (request: SurveyRisposte, thunkAPI) => {
  try {
    const response = await amlFatcaCrsSurveyRepository.postAml(
      request,
      thunkAPI
    );
    return response;
  } catch (error) {
    console.error(error);
    return thunkAPI.rejectWithValue('GENERIC_ERROR');
  }
});
